<template>
  <div class="slideshow-toolbar" v-show="isSlideshow" @mouseover="isHover = true" @mouseout="isHover = false">
    <div class="wrapper">
      <div class="btns" :style="btnsStyle">
        <el-tooltip content="슬라이드 종료" placement="top">
          <div @click="confirmOffSlideshow"><i class="fas fa-stop"></i></div>
        </el-tooltip>
        <el-tooltip content="일시정지" placement="top">
          <div v-show="!isPause" @click="isPause = true"><i class="fas fa-pause"></i></div>
        </el-tooltip>
        <el-tooltip content="재개" placement="top">
          <div v-show="isPause" @click="isPause = false"><i class="fas fa-play"></i></div>
        </el-tooltip>
        <el-tooltip content="이전 슬라이드" placement="top">
          <div @click="prevSlide"><i class="fas fa-step-backward"></i></div>
        </el-tooltip>
        <el-tooltip content="다음 슬라이드" placement="top">
          <div @click="nextSlide"><i class="fas fa-step-forward"></i></div>
        </el-tooltip>
      </div>
      <div class="time">
        <i class="far fa-clock"></i>
        <span style="margin-left: 2px;">{{countDown}}초</span>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardConst from '@/constants/dashboard';
import { isEmpty } from '@/utils/basic';

const TASK_NAME = 'dashboard_slideshow';

export default {
  name: 'WSlideshowControlbar',
  data() {
    return {
      isHover: false,
      isPause: false,
      slideList: [],
      slideIndex: 0,
      countDown: null,
    };
  },
  computed: {
    btnsStyle() {
      return {
        width: this.isHover ? '140px' : '0px',
      };
    },
    isSlideshow() {
      return this.$store.getters.getDashboardSlideshow;
    },
  },
  created() {
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.SLIDESHOW_START, this.onSlideshow);
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.SLIDESHOW_START, this.onSlideshow);

    this.offSlideshow();
  },
  methods: {
    /**
     * 데이터 초기화
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    initData() {
      this.isHover = false;
      this.isPause = false;
      this.slideList = [];
      this.slideIndex = 0;
      this.countDown = null;
    },
    /**
     * 슬라이드쇼 시작
     * @author KangBonghun(toto1323)
     * @param  {[type]} slideList [description]
     * @return {[type]}           [description]
     */
    onSlideshow(slideList) {
      this.$store.commit('setDashboardSlideshow', true);
      this.slideList = slideList;
      this.startTimer();

      this.playSide();
    },
    /**
     * 슬라이드쇼 종료
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    offSlideshow() {
      this.$store.commit('setDashboardSlideshow', false);
      this.initData();
      this.stopTimer();
    },
    /**
     * 타이머 시작
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    startTimer() {
      this.stopTimer();

      this.$taskManager.createTask(TASK_NAME, 1, this.onCountDown);
      this.$taskManager.startTask(TASK_NAME);
    },
    /**
     * 타이머 종료
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    stopTimer() {
      if (this.$taskManager.existTask(TASK_NAME)) {
        this.$taskManager.removeTask(TASK_NAME);
      }
    },
    onCountDown() {
      if (this.countDown !== null && !this.isPause) {
        if (!isNaN(this.countDown) && this.countDown !== 0 && this.countDown > 0) {
          this.countDown -= 1;
        }

        if (this.countDown === 0) {
          this.nextSlide();
        }
      }
    },
    /**
     * 슬라이드쇼 종료 확인
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    confirmOffSlideshow() {
      this.$confirm('슬라이드쇼를 종료하시겠습니까?', '확인', {
        confirmButtonText: '예',
        cancelButtonText: '아니오',
        confirmButtonClass: 'el-button--solid',
        closeOnPressEscape: false,
      })
        .then(() => {
          this.offSlideshow();
        })
        .catch(() => {})
        .finally(() => {
        });
    },
    /**
     * 다음 슬라이드
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    nextSlide() {
      if (this.slideIndex === this.slideList.length - 1) {
        this.slideIndex = 0;
      } else {
        this.slideIndex = this.slideIndex + 1;
      }

      this.playSide();
    },
    /**
     * 이전 슬라이드
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    prevSlide() {
      if (this.slideIndex === 0) {
        this.slideIndex = this.slideList.length - 1;
      } else {
        this.slideIndex = this.slideIndex - 1;
      }

      this.playSide();
    },
    /**
     * 슬라이드 이동
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    playSide() {
      if (this.isSlideshow) {
        const treeKey = this.slideList[this.slideIndex].treeKey;
        this.$router.push({
          path: (isEmpty(treeKey)) ? '/dashboard/' : `/dashboard/coord_dashboard-${treeKey}`,
        });

        this.countDown = this.slideList[this.slideIndex].delay / 1000;
      }
    },
  },
};
</script>

<style lang="scss">
.slideshow-toolbar {
  position: fixed;
  z-index: 1000;
  bottom: 20px;
  right: 20px;

  .wrapper {
    position: relative;
    float: left;
    border-radius: 3px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;
    // border: 1px solid rgba(0, 0, 0, 0.15);
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    overflow: hidden;

    .time {
      float: left;
      width: auto;
      height: 35px;
      text-align: center;
      vertical-align: middle;
      line-height: 35px;
      border-right: 1px solid rgba(233, 233, 233, 0.15);
      padding: 0px 10px;
      background: rgba(37, 143, 255, 0.7);
    }

    .btns {
      overflow: hidden;
      float: left;
      transition: width 0.3s;
      width: 0px;
      height: 35px;

      div {
        float: left;
        width: 35px;
        height: 35px;
        user-select: none;
        -webkit-user-drag: none;
        text-align: center;
        vertical-align: middle;
        line-height: 35px;
        border-right: 1px solid rgba(233, 233, 233, 0.15);

        &:last-child {
          border-right: none;
        }

        &:hover {
          background: #000;
          cursor: pointer;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/SlideshowControlbar.vue